'use client'

import { getMessages } from './messages'
import type { Messages } from './messages'
import { useAppLayoutContext } from '@/providers/AppLayoutProvider'

export function useMessages(): Messages {
  const { options } = useAppLayoutContext()
  return getMessages(options.locale)
}
